import { ReactNode, useEffect, useState } from "react";
import { CgClose } from "react-icons/cg";

/*
props: {
  items: T[];
  selections: T[];
  onSelectChange: (selected: T[]) => void;
  renderElement: (item: T, selected: boolean) => ReactNode;
}
   */

export default function CheckboxGroup({
  items,
  selections,
  onSelectChange,
  renderElement,
}) {
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    onSelectChange(selectedItems);
  }, [selectedItems]);

  return (
    <div className="flex flex-wrap gap-2 mt-4">
      {items.map((item, index) => {
        const selected = selectedItems.includes(item);
        return renderElement(item, selected);
      })}
    </div>
  );
}

/**
 * {
  selected,
  onSelect,
  children,
}: {
  selected?: boolean;
  onSelect: () => void;
  children?: ReactNode;
}
 * @param {*} param0 
 * @returns 
 */
export function CheckboxItem({ selected, onSelect, cancellabe, children, disabled = false, className }) {
  return (
    <div
      onClick={(e) => {
        if (!disabled) {
          onSelect && onSelect(e)
        }
      }}
      className={`flex gap-4 items-center justify-center min-w-20 transition duration-150 px-3 py-1.5 rounded-full border-2 border-black-100 text-sm capitalize cursor-pointer hover:bg-secondary/6 ${selected && "border-black border-2"
        } ${className} `}
    >
      {children}

      {typeof cancellabe == "boolean" && cancellabe && (
        <CgClose onClick={onSelect} className="p-1 rounded-full text-xl" />
      )}
    </div>
  );
}
